import { faList } from "@fortawesome/pro-solid-svg-icons";
import { DrawerButton } from "../../components/DrawerButton";
import { VisitorDrawerState, visitorDrawerStateAtom } from "../state";
import { ControlPanelButton } from "../../components/ControlPanelButton";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { useGetShouldShowReflectionTopics } from "./useGetShouldShowReflectionTopics";
import { Tooltip } from "@growtherapy/sprout-ui";

export function ReflectionTopicsDrawerControls({
  onClick,
  tooltipText,
}: {
  onClick: () => void;
  tooltipText: string;
}) {
  return (
    <Tooltip childIsInteractive text={tooltipText}>
      <DrawerButton
        forDrawerStates={VisitorDrawerState.REFLECTION_TOPICS}
        aria-label={tooltipText}
        iconDefinition={faList}
        as={ControlPanelButton}
        onClick={onClick}
      />
    </Tooltip>
  );
}

export function ReflectionTopicsDrawerControlsWrapper() {
  const [drawerState, setDrawerState] = useAtom(visitorDrawerStateAtom);
  const { shouldShowReflectionTopics } = useGetShouldShowReflectionTopics();
  const drawerIsOpen = drawerState === VisitorDrawerState.REFLECTION_TOPICS;
  const tooltipText = drawerIsOpen
    ? "Close session topics"
    : "Open session topics";
  const onClick = useCallback(() => {
    setDrawerState((prev) =>
      prev === VisitorDrawerState.REFLECTION_TOPICS
        ? null
        : VisitorDrawerState.REFLECTION_TOPICS,
    );
  }, [setDrawerState]);
  if (!shouldShowReflectionTopics) {
    return null;
  }
  return (
    <ReflectionTopicsDrawerControls
      onClick={onClick}
      tooltipText={tooltipText}
    />
  );
}
